"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_TYPES = exports.BUTTON_SIZES = exports.BUTTON_FEATURES = void 0;
var BUTTON_TYPES = exports.BUTTON_TYPES = {
  PRIMARY: 'btn--primary',
  SECONDARY: 'btn--secondary',
  SUCCESS: 'btn--success',
  ERROR: 'btn--error',
  WARNING: 'btn--warning',
  TRANSPARENT: 'btn--transparent',
  WHITE: 'btn--white',
  GHOST: 'btn--ghost',
  GHOST_BG: 'btn--ghost-bg',
  GHOST_PRIMARY_ICON: 'btn--ghost icon-primary',
  BARE: 'btn--bare',
  BARE_PRIMARY: 'btn--bare primary',
  BARE_WARNING: 'btn--bare warning',
  BARE_SECONDARY: 'btn--bare secondary',
  BARE_NO_PADDING: 'btn--bare no-padding',
  BARE_WHITE: 'btn--bare white',
  BARE_WHITE_NO_PADDING: 'btn--bare white no-padding',
  BARE_BLACK: 'btn--bare black',
  BARE_SECONDARY_NO_PADDING: 'btn--bare secondary no-padding',
  BARE_PRIMARY_NO_PADDING: 'btn--bare primary no-padding',
  BARE_SUCCESS_NO_PADDING: 'btn--bare success no-padding',
  BARE_CONTRAST_MEDIUM: 'btn--bare contrast-medium',
  BARE_CONTRAST_HIGH: 'btn--bare contrast-high',
  BARE_CONTRAST_MEDIUM_NO_PADDING: 'btn--bare contrast-medium no-padding',
  BARE_CONTRAST_HIGH_NO_PADDING: 'btn--bare contrast-high no-padding',
  FILTER: 'btn--filter',
  FILTER_LIST_ITEM: 'btn--filter list-item',
  FILTER_PROGRESS: 'btn--filter progress',
  FILTER_EXTENDED: 'btn--filter extended',
  FILTER_FILL: 'btn--filter fill',
  NO_STYLE: 'btn--no-style',
  INSTAGRAM: 'btn--instagram',
  FACEBOOK: 'btn--facebook',
  WHATSAPP: 'btn--whatsapp',
  DISABLED: 'btn--disabled',
  RATING_STANDARD: 'btn--rating-standard',
  RATING_PREMIUM: 'btn--rating-premium',
  RATING_PREMIUM_PLUS: 'btn--rating-premium-plus',
  RATING_BASIC: 'btn--rating-basic',
  RATING_CATERED: 'btn--rating-catered',
  TRASH: 'btn--trash',
  SQUARE_ICON: 'btn--square-icon',
  SQUARE_ICON_DISABLED: 'btn--disabled btn--square-icon',
  CIRCLE_ICON: 'btn--ghost btn--circle-icon',
  CIRCLE_ICON_GHOST: 'btn--ghost btn--circle-icon-ghost',
  CIRCLE_ICON_PRIMARY: 'btn--ghost btn--circle-icon-primary',
  CIRCLE_ICON_DISABLED: 'btn--disabled btn--circle-icon',
  INPUT: 'btn--input form-control',
  OUTLINE_PRIMARY: 'btn--outline primary',
  OUTLINE_PRIMARY_WHITE_BACKGROUND: 'btn--outline primary white-background',
  OUTLINE_SECONDARY: 'btn--outline secondary',
  OUTLINE_SECONDARY_WHITE_BACKGROUND: 'btn--outline secondary white-background',
  OUTLINE_WHITE: 'btn--white-outline',
  OUTLINE_LIGHT_GREY: 'btn--light-grey-outline',
  OUTLINE_MEDIUM_GREY: 'btn--medium-grey-outline',
  LUXURY: 'btn--luxury',
  LUXURY_PLUS: 'btn--luxury-plus',
  PREMIUM: 'btn--premium',
  APPLE_PAY: 'btn--apple-pay'
};
var BUTTON_SIZES = exports.BUTTON_SIZES = {
  SMALL: 'btn--sm',
  MEDIUM: 'btn--md',
  LARGE: 'btn--lg',
  XLARGE: 'btn--xl',
  XXLARGE: 'btn--xxl',
  XXXLARGE: 'btn--xxxl',
  LARGE_PADDING: 'btn--lg-padding'
};
var BUTTON_FEATURES = exports.BUTTON_FEATURES = {
  FULL_WIDTH: 'btn--full-width'
};